export const formatJobDate = (date?: string) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
};

export const formatJobLocation = (location?: string[]) => {
    if (!location || location.length === 0) return "-";
    return location.map(loc => loc.trim()).join(", ");
};
